import { api } from "@/api"

export const requestMagicLinkMerchantGroupAdmin =
  async (params: { email: string }) => {
    await api.post(
      "/merchant-group/web-request-group-admin-login-link/",
      {
        body: params,
        authenticated: false,
      }
    )
  }
